import React, { useContext } from 'react';
import behav1 from "../../assets/images/behav1.png";
import behav2 from "../../assets/images/behav2.png";
import { FilterContext } from '../../context/Filter';
import { useQuery } from '@tanstack/react-query';
import { fetchflatfleetdistribution } from '../../pages/FleetEdge/Fleetedgekpi'

const Driverbehavior = () => {
    const { arn: parArn, childArn } = useContext(FilterContext);

    const { data, isLoading, isError } = useQuery({
        queryKey: ['flatfleetdistribution', parArn, childArn],
        queryFn: () => fetchflatfleetdistribution(parArn, childArn),
        enabled: !!(parArn || childArn),
    });

    if (isLoading) return <div className="p-4">Loading...</div>;
    if (isError) return <div className="p-4 text-red-500">Error fetching driver behavior data.</div>;

    return (
        <div className="flex gap-4 p-4 justify-center items-center">
            {/* Red Category Box */}
            <div className="flex flex-col gap-2 border-2 border-[#FCA5A5] bg-[#FEE2E2] p-4 rounded-xl items-center">
                <img src={behav1} alt="Red Category" />
                <div className="mt-2 font-semibold">Red category</div>
                <div className="mt-2 text-lg">{data?.result?.redSum ?? 0}</div>
            </div>

            {/* Green Category Box */}
            <div className="flex flex-col gap-2 border-2 border-[#86EFAC] bg-[#DCFCE7] p-3 rounded-xl items-center">
                <img src={behav2} alt="Green Category" />
                <div className="mt-2 font-semibold">Green category</div>
                <div className="mt-2 text-lg">{data?.result?.greenSum ?? 0}</div>
            </div>
        </div>
    );
};

export default Driverbehavior;
